<img [src]="iconSrc" />
{{ label }}
